export default "__VITE_ASSET__CnsULxzh__"